import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../components/TableContent';
import { tableHeadBatchTicketRequestsData } from '../../utils';

interface SkeletonItemDesktopProps {}

export const SkeletonItemDesktop: React.FC<SkeletonItemDesktopProps> = () => {
  return (
    <TableContent direction="row">
      {tableHeadBatchTicketRequestsData.map((item) => (
        <TableContentItemColumn key={item.title} {...item} py={Spacing['inset.nano']}>
          <Skeleton
            w="100%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </TableContentItemColumn>
      ))}
    </TableContent>
  );
};
